export default {
	 compareRoles (allowedRoles, userRoles) {
		console.log(allowedRoles, userRoles);
		let match = false;

		allowedRoles.forEach((allowedRole) => {
			userRoles.forEach((userRole) => {
				if (userRole === allowedRole) match = true;
			});
		});

		return match;
	}
};



// WEBPACK FOOTER //
// ./src/helpers/permissions.js